/**
* @Author: zachalam
* @Date:   2017-01-10T17:01:31-08:00
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-07T13:20:03-07:00
*/



import React, { Component } from 'react';
import ReactPlaceholder from 'react-placeholder';
import 'react-placeholder/lib/reactPlaceholder.css';
import Container from '../../blocks/Container';
import FavoritedList from './FavoritedList';
import SubNav from '../../blocks/SubNav';
import Button from '../../blocks/Button';
import { borders } from '../../../style';

class Favorites extends Component {
  render() {
    const {
      fav,
      toggle,
      moreExists,
      loadMore,
      route
    } = this.props;

    return (
      <div>
        <SubNav
          pages={['Favorited You','Your Favorites','Visited Me']}
          urls={['/favorites', '/favorites/my', '/favorites/viewed']}
        />

        <Container>
          <ReactPlaceholder
            type='media'
            ready={!fav.isFetching}
            rows={3}
            showLoadingAnimation
            style={{backgroundColor: 'white', marginTop: '10px', border: borders.DEFAULT, padding: '16px'}}
          >
            <div>
              <FavoritedList
                favs={fav.items}
                toggle={toggle}
                noResultsTitle='You have no favorites'
                noResultsMsg=''
              />
              {moreExists && 
                  <Button fit variant="link" onClick={() => {loadMore(route.page)}}>Load More</Button>
              }
            </div>
          </ReactPlaceholder>
        </Container>
      </div>
    );
  }
}

export default Favorites;



// WEBPACK FOOTER //
// ./src/components/pages/Favorites/Favorites.jsx